import React from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ConfigProvider } from 'antd'
import { BrowserRouter } from 'react-router-dom'
import { QueryParamProvider } from 'use-query-params'
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6'

import ruRU from 'antd/locale/ru_RU'
import theme from '@app/theme'

import type { RootProviderProps } from './types'

const client = new QueryClient()

export const RootProvider: React.FC<RootProviderProps> = ({ children }) => (
  <QueryClientProvider client={ client }>
    <ConfigProvider
      locale={ ruRU }
      theme={ theme }
    >
      <BrowserRouter>
        <QueryParamProvider adapter={ ReactRouter6Adapter }>{ children }</QueryParamProvider>
      </BrowserRouter>
    </ConfigProvider>
  </QueryClientProvider>
)
